import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DemoUiService } from '../../core/demo-ui.service';
import { SECTION_COMPONENTS } from '../../shared/compound/section.components';
@Component({ selector: 'rv-community', standalone: true, imports: [...SECTION_COMPONENTS], templateUrl: './community.component.html', changeDetection: ChangeDetectionStrategy.OnPush })
export class CommunityComponent { readonly ui = inject(DemoUiService); }
